/* eslint-disable react/hook-use-state */
import { isEmptyObject, objetoTemPropriedade } from '../../utils/helpers/helpers'
import React, { useEffect, useState } from 'react'
import { object } from 'prop-types'
import { useModalidade } from '../../contexts/ModalidadeContext'
import { PAGAMENTO_CARTAO, PAGAMENTO_BOLETO, PAGAMENTO_PIX, MODALIDADE_CURADORIA, MODALIDADE_INEDITOS, INFORMACAO_MODALIDADES, ROUTE_BASEPATH } from '../../constants'
import CardPagamento from './components/CardPagamento/CardPagamento'
import ConteudoWrapper from '../../components/ConteudoWrapper/ConteudoWrapper'
import CardEnderecoEntrega from './components/CardEnderecoEntrega/CardEnderecoEntrega'
import InlineLoader from '../../components/InlineLoader/InlineLoader'
import { useGlobal } from '../../contexts/GlobalContext'
import CardAssinatura from '../Home/components/CardAssinatura'
import CardMGM from './components/CardMGM/CardMGM'
import { CartaoCreditoProvider } from '../../contexts/CartaoCreditoContext'
import { URLS_APP } from '../../config'

const Modalidade = ( { location } ) => {
  const { assinaturaPorModalidade, fetchAssinaturaPorModalidade } = useModalidade()
  const { pegarVideosRetencao } = useModalidade()
  const [ dadosPagamento, setDadosPagamento ] = useState( {} )
  const [ , setControlesDaAssinatura ] = useState( {} )
  const { dadosGlobaisAssociado, modalidadeURL, setModalidadeURL } = useGlobal( {} )
  const [ modalidadeCuradoria, setModalidadeCuradoria ] = useState()
  const [ modalidadeIneditos, setModalidadeIneditos ] = useState()
  const [ , setModalidadeAssinatura ] = useState()
  const { 'slug': curadoriaSlug, 'visualizacao': curadoriaVisualizacao } = MODALIDADE_CURADORIA
  const { 'slug': ineditosSlug, 'visualizacao': ineditosVisualizacao } = MODALIDADE_INEDITOS

  const getNameModalidade = () => {
    if ( modalidadeURL === 'curadoria' ) {
      return 'Curadoria'
    }
    if ( modalidadeURL === 'ineditos' ) {
      return 'Inéditos'
    }
    return ''
  }

  const dadosCardPagamento = pagamento => {
    let opcoes = {}
    if ( pagamento === PAGAMENTO_BOLETO ) {
      opcoes = {
        [ PAGAMENTO_BOLETO ]: {
          'info': assinaturaPorModalidade.pagamento.metodo
        }
      }
    } else if ( pagamento === PAGAMENTO_CARTAO ) {
      opcoes = {
        [ PAGAMENTO_CARTAO ]: {
          'info': assinaturaPorModalidade.pagamento.metodo,
          ...assinaturaPorModalidade.pagamento.cartaoCredito
        }
      }
    } else if ( pagamento === PAGAMENTO_PIX ) {
      opcoes = {
        [ PAGAMENTO_PIX ]: {
          'info': assinaturaPorModalidade.pagamento.metodo
        }
      }
    }

    return opcoes[ pagamento ]
  }

  useEffect( () => {
    const modalidadeIncluidaPathname = location.pathname.split( '/' ).find( path => {
      const infoModalidadeIncluidaNoPathname = INFORMACAO_MODALIDADES.find( modalidade => modalidade.slug === path )
      return !isEmptyObject( infoModalidadeIncluidaNoPathname )
    } )

    setModalidadeURL( modalidadeIncluidaPathname )
  }, [ location ] )

  useEffect( () => {
    if ( modalidadeURL ) {
      fetchAssinaturaPorModalidade( modalidadeURL )
    }
  }, [ modalidadeURL ] )

  useEffect( () => {
    if ( dadosGlobaisAssociado && objetoTemPropriedade( dadosGlobaisAssociado, 'assinaturas' ) ) {
      const controleModalidades = [
        [ MODALIDADE_CURADORIA.id, setModalidadeCuradoria ],
        [ MODALIDADE_INEDITOS.id, setModalidadeIneditos ]
      ]

      for ( const [ modalidadeId, modalidadeSetter ] of controleModalidades ) {
        const modalidadeAssinaturaAssociado = dadosGlobaisAssociado.modalidades.find( mod => mod.id === modalidadeId )
        if ( modalidadeAssinaturaAssociado ) {
          modalidadeSetter( modalidadeAssinaturaAssociado )
        }
      }
    }
  }, [ dadosGlobaisAssociado, modalidadeURL ] )

  useEffect( () => {
    let modalidade
    if ( dadosGlobaisAssociado ) {
      if ( modalidadeURL === curadoriaSlug ) {
        modalidade = curadoriaVisualizacao
        setModalidadeAssinatura( modalidadeCuradoria )
      } else if ( modalidadeURL === ineditosSlug ) {
        modalidade = ineditosVisualizacao
        setModalidadeAssinatura( modalidadeIneditos )
      }

      const assinaturaObtida = dadosGlobaisAssociado.assinaturas.find( assinatura => assinatura.modalidade === modalidade )

      if ( assinaturaObtida ) {
        setControlesDaAssinatura( assinaturaObtida.controles )
        pegarVideosRetencao()
      }
    }
  }, [ dadosGlobaisAssociado, modalidadeCuradoria, modalidadeIneditos, modalidadeURL ] )

  useEffect( () => {
    if ( !isEmptyObject( assinaturaPorModalidade ) ) {
      const pagamento = dadosCardPagamento( assinaturaPorModalidade.pagamento.metodo )
      setDadosPagamento( pagamento )
    }
  }, [ assinaturaPorModalidade ] )

  const showSaibaMais = () => {
    const assinatura = dadosGlobaisAssociado.assinaturas.find( item => item?.modalidade === getNameModalidade() )
    return assinatura.status === 'Ativo' && assinatura.renovacaoAutomatica
  }

  return !isEmptyObject( assinaturaPorModalidade ) ? (
    <>
      {/* { !isEmptyObject( videosRetencao ) && videosRetencao[ modalidadeURL ].urlVideo &&
          <VideoWrapper>
            <CardVideo
              onFinalizar={ onFinalizarVideo }
              onIniciar={ onIniciarVideo }
              subtitulo={ videosRetencao[ modalidadeURL ].subtitulo }
              titulo={ videosRetencao[ modalidadeURL ].titulo }
              urlVideo={ videosRetencao[ modalidadeURL ].urlVideo }
            />
          </VideoWrapper> } */}

      <ConteudoWrapper>
        {dadosGlobaisAssociado ? (
          <CartaoCreditoProvider>
            <CardAssinatura
              assinatura={ dadosGlobaisAssociado.assinaturas.find( assinatura => assinatura?.modalidade === getNameModalidade() ) }
              dadosGlobaisAssociado={ dadosGlobaisAssociado }
              modalidade={ modalidadeURL }
              showEnvios={ false }
              showSaibaMais={ showSaibaMais() }
              verMaisUrl={ `${ROUTE_BASEPATH}${URLS_APP.BASE_PATH ? '/' : ''}${
                getNameModalidade() === 'Curadoria'
                  ? 'curadoria/plano'
                  : 'ineditos/plano'
              }` }
            />
          </CartaoCreditoProvider>
        ) : (
          <InlineLoader isCenter />
        )}

        <CardEnderecoEntrega
          endereco={ assinaturaPorModalidade.entrega.endereco }
          tituloHomeModalidade
        />

        {!isEmptyObject( dadosPagamento ) && (
          <CardPagamento
            dados={ dadosPagamento }
            metodoPagamento={ assinaturaPorModalidade.pagamento.metodo }
          />
        )}

        {/* <CardMGM
          codigoIndicacao={
            dadosGlobaisAssociado ? dadosGlobaisAssociado.associado.codigoIndicacao : null
          }
        /> */}

        {/* <Slick modalidadeURL={ modalidadeURL } /> */}
      </ConteudoWrapper>
    </>
  ) : (
    <InlineLoader isCenter />
  )
}

Modalidade.propTypes = {
  'location': object.isRequired
}

export default Modalidade

